import _defineProperty from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { __rest } from "tslib";
import * as React from 'react';
import { css } from '@patternfly/react-styles';
import styles from '@patternfly/react-styles/css/components/AboutModalBox/about-modal-box'; // eslint-disable-next-line camelcase

import c_about_modal_box__hero_sm_BackgroundImage from '@patternfly/react-tokens/dist/js/c_about_modal_box__hero_sm_BackgroundImage';
export var AboutModalBoxHero = function AboutModalBoxHero(_a) {
  var className = _a.className,
      backgroundImageSrc = _a.backgroundImageSrc,
      props = __rest(_a, ["className", "backgroundImageSrc"]);

  return React.createElement("div", Object.assign({
    style:
    /* eslint-disable camelcase */
    backgroundImageSrc !== '' ? _defineProperty({}, c_about_modal_box__hero_sm_BackgroundImage.name, "url(".concat(backgroundImageSrc, ")")) : {},
    className: css(styles.aboutModalBoxHero, className)
  }, props));
};